import { ReactNode } from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

import { getPlacementClasses, getTriangleClasses, getVariantClasses, getTriangleVariantClasses } from './Tips.utils';

import { TTipVariant, TTipPlacement } from './Tips.types';

export interface IMessageAreaProps {
  children: ReactNode;
  variant?: TTipVariant;
  placement?: TTipPlacement;
  hasArrow?: boolean;
  className?: string;
}

export function MessageArea({
  variant = 'primary',
  placement = 'top',
  hasArrow = true,
  children,
  className,
}: IMessageAreaProps) {
  return (
    <div
      className={twMerge(
        'absolute z-100 px-5 py-4 shadow-100 rounded-100 w-fit',
        getVariantClasses(variant),
        getPlacementClasses(placement),
        className,
      )}
    >
      {children}
      {hasArrow && (
        <div
          className={clsx(
            'absolute h-3 w-3 shadow-100',
            getTriangleVariantClasses(variant),
            getTriangleClasses(placement),
          )}
        />
      )}
    </div>
  );
}
